// Gathering types a host can pick from. Names and descriptions live in the
// translation files under `types.<id>`. `gendered` types offer the
// girl / boy / neutral choice that recolours the invitation.
export const EVENT_TYPES = [
  { id: "wedding", emoji: "💍", color: "#e91e7a", mealsByDefault: true },
  { id: "birthday", emoji: "🎂", color: "#ff9500", mealsByDefault: false, gendered: true },
  { id: "meeting", emoji: "💼", color: "#2563eb", mealsByDefault: false },
  { id: "babyshower", emoji: "🍼", color: "#7fb2e5", mealsByDefault: false, gendered: true },
  { id: "graduation", emoji: "🎓", color: "#0f9d6b", mealsByDefault: false },
  { id: "dinner", emoji: "🍽️", color: "#c2623f", mealsByDefault: true },
  { id: "other", emoji: "🎉", color: "#7b2ff7", mealsByDefault: false },
];

export const getEventType = (id) =>
  EVENT_TYPES.find((type) => type.id === id) || EVENT_TYPES[EVENT_TYPES.length - 1];

export const DIET_TAGS = ["none", "vegetarian", "vegan", "halal", "glutenFree", "kids"];
